import * as React from 'react';
import s from '../Cycles/Cycles.scss';
import { Text } from '@wix/design-system';
import { Trans } from 'react-i18next';
import { AdvancedPlansFeature } from 'types';
import { usePremiumCurrencyFormatter } from '@wix/premium-react-text';
import { getAdVoucherTransParams } from 'utils';
import { withInjectedRootStore, RootStore } from 'providers';
import { TruncatedTextWrapper } from 'components/TruncatedTextTooltip';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';

interface MissingFeaturesListProps extends InjectedExperimentsProps {
  missingFeatures: AdvancedPlansFeature[];
  rootStore: RootStore;
}

const MissingFeaturesListComp: React.FC<MissingFeaturesListProps> = ({
  missingFeatures,
  rootStore,
  experiments,
}) => {
  const {
    amountToSpend,
    amount,
    currencyCode,
  } = rootStore.appStore.googleVoucherAmounts;
  const { requestParamsMap } = rootStore.appStore.appContext;
  const [currencyToString] = usePremiumCurrencyFormatter({
    currencyCode,
  });
  const voucherTransParams = getAdVoucherTransParams(
    currencyToString,
    amount,
    amountToSpend,
  );
  const domainFeatureTransParams = {
    domain: requestParamsMap.domainName,
  };

  const transParams = { ...voucherTransParams, ...domainFeatureTransParams };
  const translationTags = {
    b: <b />,
    ellipsis: (
      <TruncatedTextWrapper
        dataHook='truncated-domain-name'
        text={requestParamsMap.domainName}
        maxWidth={136}
        maxTextLength={17}
        componentProps={{
          weight: 'bold',
          size: 'small',
        }}
      />
    ),
  };

  return (
    <Text
      tagName='div'
      weight='normal'
      size='small'
      className={s.missingFeaturesList}
    >
      <ul>
        {missingFeatures.map((feature, index) => (
          <li key={index} data-hook='monthly-disclaimer-missing-feature'>
            <div className={s.xMark} />
            <Trans
              i18nKey={feature.translationKey}
              components={translationTags}
              values={transParams}
            />
          </li>
        ))}
      </ul>
    </Text>
  );
};

export const MissingFeaturesList = withExperiments(
  withInjectedRootStore(MissingFeaturesListComp),
);
